import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { canManageSso } from '@/host/access';
import { EmailView } from '@/platform/orgs/EmailView';

export const Route = createFileRoute('/_app/email')({
   beforeLoad: ({ context }) => {
      if (!canManageSso(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: () => <EmailView scope="org" />
});
